/*!
 * Monsieur Carpe : Conditions du jour (assets/mc-conditions.js), v1.0 du 07/10/2026
 * Aucun cookie, aucun script tiers. Chargé uniquement sur /pages/conditions-du-jour.
 * Réseau : recherche de ville (Géoplateforme de l'IGN par défaut) et météo (Open-Meteo, si activée), seulement après un geste du visiteur (« Utiliser ma position »,
 * recherche de ville) ou s'il a lui-même demandé à mémoriser son lieu sur cet appareil.
 * localStorage : clé « mc-cdj-lieu » (nom du lieu, latitude et longitude arrondies),
 * écrite seulement si la case « Mémoriser ce lieu » est cochée ; bouton « Oublier ce lieu ».
 * Astronomie calculée dans le navigateur :
 *  - instants des nouvelles et pleines lunes : J. Meeus, Astronomical Algorithms, 2e éd., chap. 49 ;
 *  - élongation et illumination : Meeus, chap. 48 (formule 48.4) ;
 *  - positions basse précision et levers/couchers : formules d'Astronomy Answers (aa.quae.nl),
 *    balayage horaire avec interpolation quadratique, méthode popularisée par SunCalc
 *    (V. Agafonkin, licence BSD-2). Précision : quelques minutes.
 */
(function () {
  'use strict';
  var root = document.querySelector('[data-mc-conditions]');
  if (!root || root.getAttribute('data-mc-pret')) return;
  root.setAttribute('data-mc-pret', '1');

  /* ---------- Astronomie ---------- */
  var PI = Math.PI, RAD = PI / 180, DAY = 864e5, J1970 = 2440588, J2000 = 2451545, OBL = RAD * 23.4397;
  function sin(x) { return Math.sin(x); }
  function sind(x) { return Math.sin(x * RAD); }
  function d2000(ms) { return ms / DAY - 0.5 + J1970 - J2000; }
  function raDec(l, b) {
    return {
      ra: Math.atan2(sin(l) * Math.cos(OBL) - Math.tan(b) * sin(OBL), Math.cos(l)),
      dec: Math.asin(sin(b) * Math.cos(OBL) + Math.cos(b) * sin(OBL) * sin(l))
    };
  }
  function hauteur(d, c, lat, lon) {
    var H = RAD * (280.16 + 360.9856235 * d) + lon * RAD - c.ra;
    return Math.asin(sin(lat * RAD) * sin(c.dec) + Math.cos(lat * RAD) * Math.cos(c.dec) * Math.cos(H));
  }
  function coordSoleil(d) {
    var M = RAD * (357.5291 + 0.98560028 * d),
      C = RAD * (1.9148 * sin(M) + 0.02 * sin(2 * M) + 0.0003 * sin(3 * M));
    return raDec(M + C + RAD * 102.9372 + PI, 0);
  }
  function coordLune(d) {
    var L = RAD * (218.3164 + 13.17639648 * d), M = RAD * (134.9634 + 13.06499295 * d),
      F = RAD * (93.2721 + 13.22935024 * d), D = RAD * (297.8502 + 12.19074912 * d),
      S = RAD * (357.5291 + 0.98560028 * d);
    var l = L + RAD * (6.2888 * sin(M) + 1.274 * sin(2 * D - M) + 0.6583 * sin(2 * D) + 0.2136 * sin(2 * M) - 0.1851 * sin(S) - 0.1143 * sin(2 * F)),
      b = RAD * (5.1281 * sin(F) + 0.2806 * sin(M + F) + 0.2777 * sin(M - F) + 0.1732 * sin(2 * D - F)),
      c = raDec(l, b);
    c.dist = 385000.6 - 20905.4 * Math.cos(M) - 3699.1 * Math.cos(2 * D - M) - 2956 * Math.cos(2 * D);
    return c;
  }
  // Fraction de lunaison (0 = nouvelle, 0,5 = pleine) et part éclairée, d'après l'élongation vraie approchée.
  function phase(ms) {
    var d = d2000(ms), D = 297.8502 + 12.19074912 * d, M = 357.5291 + 0.98560028 * d, Mp = 134.9634 + 13.06499295 * d;
    var psi = D + 6.289 * sind(Mp) - 2.1 * sind(M) + 1.274 * sind(2 * D - Mp) + 0.658 * sind(2 * D) + 0.214 * sind(2 * Mp) + 0.11 * sind(D);
    psi = ((psi % 360) + 360) % 360;
    return { f: psi / 360, k: (1 - Math.cos(psi * RAD)) / 2, psi: psi };
  }
  var TN = [-.4072, .17241, .01608, .01039, .00739, -.00514, .00208, -.00111, -.00057, .00056, -.00042, .00042, .00038, -.00024, -.00017, -.00007, .00004, .00004, .00003, .00003, -.00003, .00003, -.00002, -.00002, .00002],
    TF = [-.40614, .17302, .01614, .01043, .00734, -.00515, .00209, -.00111, -.00057, .00056, -.00042, .00042, .00038, -.00024, -.00017, -.00007, .00004, .00004, .00003, .00003, -.00003, .00003, -.00002, -.00002, .00002],
    PA = [[299.77, .107408, .000325], [251.88, .016321, .000165], [251.83, 26.651886, .000164], [349.42, 36.412478, .000126], [84.66, 18.206239, .00011], [141.74, 53.303771, .000062], [207.14, 2.453732, .00006], [154.84, 7.30686, .000056], [34.52, 27.261239, .000047], [207.19, .121824, .000042], [291.34, 1.844379, .00004], [161.72, 24.198154, .000037], [239.56, 25.513099, .000035], [331.55, 3.592518, .000023]];
  // Instant (ms, UTC) de la nouvelle lune k entière, ou de la pleine lune k + 0,5 (Meeus 49).
  function lunaison(k) {
    var T = k / 1236.85, T2 = T * T, i,
      J = 2451550.09766 + 29.530588861 * k + .00015437 * T2 - .00000015 * T2 * T + .00000000073 * T2 * T2,
      E = 1 - .002516 * T - .0000074 * T2,
      M = 2.5534 + 29.1053567 * k - .0000014 * T2,
      P = 201.5643 + 385.81693528 * k + .0107582 * T2 + .00001238 * T2 * T,
      F = 160.7108 + 390.67050284 * k - .0016118 * T2 - .00000227 * T2 * T,
      O = 124.7746 - 1.56375588 * k + .0020672 * T2,
      a = [sind(P), E * sind(M), sind(2 * P), sind(2 * F), E * sind(P - M), E * sind(P + M), E * E * sind(2 * M), sind(P - 2 * F), sind(P + 2 * F), E * sind(2 * P + M), sind(3 * P), E * sind(M + 2 * F), E * sind(M - 2 * F), E * sind(2 * P - M), sind(O), sind(P + 2 * M), sind(2 * P - 2 * F), sind(3 * M), sind(P + M - 2 * F), sind(2 * P + 2 * F), sind(P + M + 2 * F), sind(P - M + 2 * F), sind(P - M - 2 * F), sind(3 * P + M), sind(4 * P)],
      t = (k % 1) ? TF : TN;
    for (i = 0; i < 25; i++) J += t[i] * a[i];
    for (i = 0; i < 14; i++) J += PA[i][2] * sind(PA[i][0] + PA[i][1] * k - (i ? 0 : .009173 * T2));
    return (J + 0.5 - J1970) * DAY - 69e3; // temps terrestre vers UTC (delta T d'environ 69 s)
  }
  function evenements(ms) {
    var k0 = Math.floor((d2000(ms) / 365.25) * 12.3685), r = {}, k, j, kk, t, n;
    for (k = k0 - 2; k <= k0 + 3; k++) {
      for (j = 0; j < 2; j++) {
        kk = k + j / 2; t = lunaison(kk); n = j ? 'Pleine' : 'Nouvelle';
        if (t <= ms && (!r['prec' + n] || t > r['prec' + n])) r['prec' + n] = t;
        if (t > ms && (!r['proch' + n] || t < r['proch' + n])) r['proch' + n] = t;
      }
    }
    return r;
  }
  // Lever et coucher sur 24 h à partir de t0 ; g(t) = hauteur moins hauteur de référence.
  function leverCoucher(t0, g) {
    var lever = null, coucher = null, h0 = g(t0), i;
    for (i = 1; i <= 24; i += 2) {
      var h1 = g(t0 + i * 36e5), h2 = g(t0 + (i + 1) * 36e5),
        a = (h0 + h2) / 2 - h1, b = (h2 - h0) / 2, xe = -b / (2 * a), ye = (a * xe + b) * xe + h1,
        dd = b * b - 4 * a * h1, n = 0, x1, x2, dx;
      if (dd >= 0) {
        dx = Math.sqrt(dd) / (Math.abs(a) * 2); x1 = xe - dx; x2 = xe + dx;
        if (Math.abs(x1) <= 1) n++;
        if (Math.abs(x2) <= 1) n++;
        if (x1 < -1) x1 = x2;
      }
      if (n === 1) { if (h0 < 0) lever = i + x1; else coucher = i + x1; }
      else if (n === 2) { lever = i + (ye < 0 ? x2 : x1); coucher = i + (ye < 0 ? x1 : x2); }
      if (lever !== null && coucher !== null) break;
      h0 = h2;
    }
    return {
      lever: lever === null ? null : t0 + lever * 36e5,
      coucher: coucher === null ? null : t0 + coucher * 36e5,
      toujoursLevee: lever === null && coucher === null && g(t0) > 0
    };
  }
  function soleil(t0, lat, lon) {
    return leverCoucher(t0, function (t) { var d = d2000(t); return hauteur(d, coordSoleil(d), lat, lon) + 0.833 * RAD; });
  }
  function lune(t0, lat, lon) {
    return leverCoucher(t0, function (t) {
      var d = d2000(t), c = coordLune(d), par = Math.asin(6378.14 / c.dist);
      return hauteur(d, c, lat, lon) - (0.7275 * par - 0.5667 * RAD);
    });
  }

  /* ---------- Textes (à harmoniser avec la carte 4 si besoin) ---------- */
  var NOMS = ['Nouvelle lune', 'Premier croissant', 'Premier quartier', 'Gibbeuse croissante', 'Pleine lune', 'Gibbeuse décroissante', 'Dernier quartier', 'Dernier croissant'];
  function nomPhase(psi) {
    var cibles = [0, 90, 180, 270], i, ecart;
    for (i = 0; i < 4; i++) {
      ecart = Math.abs(((psi - cibles[i] + 540) % 360) - 180);
      if (ecart < 6.1) return NOMS[i * 2]; // environ ±12 h autour de la phase principale
    }
    return NOMS[Math.floor(psi / 90) * 2 + 1];
  }
  var CIEL = { 0: 'Ciel dégagé', 1: 'Plutôt dégagé', 2: 'Partiellement nuageux', 3: 'Couvert', 45: 'Brouillard', 48: 'Brouillard givrant', 51: 'Bruine faible', 53: 'Bruine modérée', 55: 'Bruine dense', 56: 'Bruine verglaçante', 57: 'Bruine verglaçante dense', 61: 'Pluie faible', 63: 'Pluie modérée', 65: 'Forte pluie', 66: 'Pluie verglaçante', 67: 'Forte pluie verglaçante', 71: 'Neige faible', 73: 'Neige modérée', 75: 'Forte neige', 77: 'Grains de neige', 80: 'Averses faibles', 81: 'Averses modérées', 82: 'Averses violentes', 85: 'Averses de neige', 86: 'Fortes averses de neige', 95: 'Orage', 96: 'Orage avec grêle', 97: 'Fort orage', 99: 'Orage avec forte grêle' };
  var VENTS = ['du nord', 'du nord-est', "de l'est", 'du sud-est', 'du sud', 'du sud-ouest', "de l'ouest", 'du nord-ouest'];

  /* ---------- Outils ---------- */
  var nb0 = new Intl.NumberFormat('fr-FR', { maximumFractionDigits: 0 });
  var nb2 = new Intl.NumberFormat('fr-FR', { maximumFractionDigits: 2, minimumFractionDigits: 2 });
  function q(sel) { return root.querySelector(sel); }
  function ecrire(sel, txt) { var el = q(sel); if (el) el.textContent = txt; }
  function parts(ms, tz, opts) {
    var o = {}, f;
    opts.timeZone = tz || undefined;
    f = new Intl.DateTimeFormat('fr-FR', opts).formatToParts(new Date(ms));
    f.forEach(function (p) { o[p.type] = p.value; });
    return o;
  }
  function heure(ms, tz) {
    if (ms === null || ms === undefined) return '—';
    var p = parts(ms, tz, { hour: 'numeric', minute: '2-digit', hourCycle: 'h23' });
    return Number(p.hour) + ' h ' + p.minute;
  }
  function jour(ms, tz) {
    var p = parts(ms, tz, { weekday: 'long', day: 'numeric', month: 'long' });
    return p.weekday + ' ' + p.day + ' ' + p.month;
  }
  function decalage(ms, tz) {
    var p = parts(ms, tz, { year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', minute: 'numeric', second: 'numeric', hourCycle: 'h23' });
    return Date.UTC(+p.year, +p.month - 1, +p.day, +p.hour, +p.minute, +p.second) - Math.floor(ms / 1000) * 1000;
  }
  function minuitLocal(ms, tz) {
    var p = parts(ms, tz, { year: 'numeric', month: 'numeric', day: 'numeric' }),
      g = Date.UTC(+p.year, +p.month - 1, +p.day);
    return g - decalage(g - decalage(g, tz), tz);
  }
  function svgLune(f, r) {
    // Disque éclairé vu de l'hémisphère nord : partie droite éclairée quand la lune croît.
    var c = Math.cos(2 * PI * f), rx = Math.abs(c) * r, croit = f < 0.5,
      s2 = ((c > 0) === croit) ? 0 : 1, s1 = croit ? 1 : 0;
    if (f < 0.005 || f > 0.995) return '';
    return 'M0 ' + (-r) + 'A' + r + ' ' + r + ' 0 0 ' + s1 + ' 0 ' + r + 'A' + rx.toFixed(2) + ' ' + r + ' 0 0 ' + s2 + ' 0 ' + (-r) + 'Z';
  }
  function annoncer(txt) { ecrire('[data-mc-statut]', txt); }
  function charger(url) {
    var ctl = window.AbortController ? new AbortController() : null,
      minuterie = setTimeout(function () { if (ctl) ctl.abort(); }, 9000);
    return fetch(url, ctl ? { signal: ctl.signal, credentials: 'omit', referrerPolicy: 'strict-origin-when-cross-origin' } : {}).then(function (r) {
      clearTimeout(minuterie);
      if (!r.ok) throw new Error('HTTP ' + r.status);
      return r.json();
    });
  }

  /* ---------- Configuration (fournie par la section) ---------- */
  var cfg = {
    api: (root.getAttribute('data-api') || 'https://api.open-meteo.com').replace(/\/$/, ''),
    geo: (root.getAttribute('data-geo') || 'https://geocoding-api.open-meteo.com').replace(/\/$/, ''),
    geoFr: (root.getAttribute('data-geo-fr') || 'https://data.geopf.fr').replace(/\/$/, ''),
    geocodeur: root.getAttribute('data-geocodeur') || 'geoplateforme',
    cle: root.getAttribute('data-cle') || '',
    meteo: root.getAttribute('data-meteo') !== '0'
  };
  var CLE_LIEU = 'mc-cdj-lieu';

  /* ---------- Bloc lune (sans réseau, affiché tout de suite) ---------- */
  function afficherLune() {
    var maintenant = Date.now(), p = phase(maintenant), ev = evenements(maintenant),
      age = (maintenant - ev.precNouvelle) / DAY, chemin = svgLune(p.f, 50), el;
    ecrire('[data-mc-lune-nom]', nomPhase(p.psi));
    ecrire('[data-mc-lune-illum]', nb0.format(Math.round(p.k * 100)) + ' %');
    ecrire('[data-mc-lune-age]', nb0.format(Math.floor(age)) + (Math.floor(age) > 1 ? ' jours' : ' jour'));
    ecrire('[data-mc-lune-pleine]', jour(ev.prochPleine) + ', ' + heure(ev.prochPleine));
    ecrire('[data-mc-lune-nouvelle]', jour(ev.prochNouvelle) + ', ' + heure(ev.prochNouvelle));
    el = q('[data-mc-lune-eclairee]');
    if (el) el.setAttribute('d', chemin);
    el = q('[data-mc-lune-disque]');
    if (el) el.setAttribute('aria-label', nomPhase(p.psi) + ', ' + Math.round(p.k * 100) + ' % éclairée');
  }

  /* ---------- Lieu : position, recherche, mémorisation ---------- */
  function lireLieu() {
    try { var v = JSON.parse(localStorage.getItem(CLE_LIEU) || 'null'); return v && typeof v.a === 'number' ? v : null; }
    catch (e) { return null; }
  }
  function memoriser(lieu) {
    var coche = q('[data-mc-memoriser]');
    try {
      if (coche && coche.checked) localStorage.setItem(CLE_LIEU, JSON.stringify({ l: lieu.l, a: lieu.a, o: lieu.o }));
    } catch (e) { /* stockage indisponible : on continue sans mémoriser */ }
    majMemoire();
  }
  function majMemoire() {
    var lieu = lireLieu(), bloc = q('[data-mc-memoire]');
    if (!bloc) return;
    bloc.hidden = !lieu;
    if (lieu) ecrire('[data-mc-memoire-nom]', lieu.l);
  }
  function arrondi(x) { return Math.round(x * 100) / 100; }

  function utiliserPosition() {
    if (!navigator.geolocation) { annoncer("Ton navigateur ne donne pas ta position. Cherche ta ville juste en dessous."); return; }
    annoncer('Recherche de ta position…');
    navigator.geolocation.getCurrentPosition(function (pos) {
      var a = arrondi(pos.coords.latitude), o = arrondi(pos.coords.longitude);
      choisirLieu({ l: 'Ta position (' + nb2.format(Math.abs(a)) + (a >= 0 ? ' N' : ' S') + ', ' + nb2.format(Math.abs(o)) + (o >= 0 ? ' E' : ' O') + ')', a: a, o: o });
    }, function (err) {
      annoncer(err && err.code === 1
        ? "Position refusée : rien n'a été envoyé. Cherche ta ville juste en dessous."
        : "Position introuvable pour l'instant. Cherche ta ville juste en dessous.");
    }, { enableHighAccuracy: false, timeout: 10000, maximumAge: 600000 });
  }

  function chercherVille(nom) {
    var liste = q('[data-mc-resultats]');
    nom = (nom || '').trim();
    if (nom.length < 2) { annoncer('Tape au moins deux lettres du nom de ta ville.'); return; }
    annoncer('Recherche de « ' + nom + ' »…');
    if (liste) liste.innerHTML = '';
    var gp = cfg.geocodeur !== 'open-meteo',
      url = gp
        ? cfg.geoFr + '/geocodage/search?q=' + encodeURIComponent(nom) + '&type=municipality&limit=6'
        : cfg.geo + '/v1/search?name=' + encodeURIComponent(nom) + '&count=6&language=fr&format=json' + (cfg.cle ? '&apikey=' + encodeURIComponent(cfg.cle) : '');
    charger(url).then(function (data) {
      var res = gp ? ((data && data.features) || []).map(versLieuFr) : ((data && data.results) || []).map(versLieuOm);
      if (!res.length) { annoncer('Aucune ville trouvée pour « ' + nom + ' ». Vérifie l’orthographe ou essaie une ville voisine.'); return; }
      res.forEach(function (r) {
        var li = document.createElement('li'), b = document.createElement('button');
        b.type = 'button';
        b.className = 'mc-cdj__choix';
        b.textContent = r.texte;
        b.addEventListener('click', function () {
          liste.innerHTML = '';
          choisirLieu(r.lieu);
        });
        li.appendChild(b);
        liste.appendChild(li);
      });
      annoncer(res.length + (res.length > 1 ? ' villes trouvées : choisis la tienne dans la liste.' : ' ville trouvée : choisis-la dans la liste.'));
      var premier = liste.querySelector('button');
      if (premier) premier.focus();
    }).catch(function () {
      annoncer('La recherche de ville ne répond pas. Réessaie dans un instant.');
    });
  }

  // Géoplateforme (IGN, communes françaises) : properties.label, properties.context, geometry.coordinates [lon, lat]
  var TZ_OUTREMER = { '971': 'America/Guadeloupe', '972': 'America/Martinique', '973': 'America/Cayenne', '974': 'Indian/Reunion', '975': 'America/Miquelon', '976': 'Indian/Mayotte' };
  function versLieuFr(f) {
    var p = f.properties || {}, c = (f.geometry && f.geometry.coordinates) || [0, 0],
      dep = String(p.context || '').split(',')[0].trim(), ctx = String(p.context || '').split(',').slice(1).join(',').trim();
    return {
      texte: (p.label || p.name || '') + (ctx ? ' (' + ctx + ')' : ''),
      lieu: { l: (p.label || p.name || '') + (dep ? ' (' + dep + ')' : ''), a: arrondi(c[1]), o: arrondi(c[0]), tz: TZ_OUTREMER[dep] || 'Europe/Paris' }
    };
  }
  function versLieuOm(r) {
    var detail = [r.admin1, r.country].filter(Boolean).join(', ');
    return {
      texte: r.name + (detail ? ' (' + detail + ')' : ''),
      lieu: { l: r.name + (r.admin1 ? ', ' + r.admin1 : ''), a: arrondi(r.latitude), o: arrondi(r.longitude), tz: r.timezone }
    };
  }

  function choisirLieu(lieu) {
    memoriser(lieu);
    ecrire('[data-mc-lieu-nom]', lieu.l);
    var bloc = q('[data-mc-local]');
    if (bloc) bloc.hidden = false;
    afficherAstresLocaux(lieu, lieu.tz);
    if (!cfg.meteo) { annoncer('Lever et coucher calculés pour ' + lieu.l + '.'); return; }
    annoncer('Chargement de la météo pour ' + lieu.l + '…');
    var url = cfg.api + '/v1/forecast?latitude=' + lieu.a + '&longitude=' + lieu.o +
      '&current=temperature_2m,weather_code,wind_speed_10m,wind_direction_10m,wind_gusts_10m,pressure_msl' +
      '&hourly=pressure_msl&past_hours=24&forecast_hours=25&timezone=auto&wind_speed_unit=kmh' +
      (cfg.cle ? '&apikey=' + encodeURIComponent(cfg.cle) : '');
    charger(url).then(function (data) {
      if (data.timezone && data.timezone !== lieu.tz) afficherAstresLocaux(lieu, data.timezone);
      afficherMeteo(data);
      annoncer('Conditions affichées pour ' + lieu.l + '.');
      var titre = q('[data-mc-local-titre]');
      if (titre) titre.focus();
    }).catch(function () {
      var m = q('[data-mc-meteo]');
      if (m) m.hidden = true;
      annoncer('La météo ne répond pas pour l’instant. Lune et soleil restent calculés pour ' + lieu.l + '.');
    });
  }

  function afficherAstresLocaux(lieu, tz) {
    var t0 = minuitLocal(Date.now(), tz), s = soleil(t0, lieu.a, lieu.o), l = lune(t0, lieu.a, lieu.o);
    ecrire('[data-mc-soleil-lever]', heure(s.lever, tz));
    ecrire('[data-mc-soleil-coucher]', heure(s.coucher, tz));
    ecrire('[data-mc-lune-lever]', l.lever === null ? 'pas de lever ce jour' : heure(l.lever, tz));
    ecrire('[data-mc-lune-coucher]', l.coucher === null ? 'pas de coucher ce jour' : heure(l.coucher, tz));
  }

  function afficherMeteo(d) {
    var c = d.current || {}, h = d.hourly || {}, p = h.pressure_msl || [], t = h.time || [],
      m = q('[data-mc-meteo]'), i, idx = -1, maintenant = c.time ? c.time.slice(0, 13) : '';
    if (m) m.hidden = false;
    ecrire('[data-mc-temp]', typeof c.temperature_2m === 'number' ? nb0.format(Math.round(c.temperature_2m)) + ' °C' : 'n.c.');
    ecrire('[data-mc-ciel]', CIEL[c.weather_code] || '');
    var vent = typeof c.wind_speed_10m === 'number'
      ? 'Vent ' + VENTS[Math.round(((c.wind_direction_10m || 0) % 360) / 45) % 8] + ', ' + nb0.format(Math.round(c.wind_speed_10m)) + ' km/h'
      + (typeof c.wind_gusts_10m === 'number' ? ', rafales ' + nb0.format(Math.round(c.wind_gusts_10m)) + ' km/h' : '')
      : 'Vent : n.c.';
    ecrire('[data-mc-vent]', vent);
    ecrire('[data-mc-pression]', typeof c.pressure_msl === 'number' ? nb0.format(Math.round(c.pressure_msl)) + ' hPa' : 'n.c.');
    for (i = 0; i < t.length; i++) { if (t[i].slice(0, 13) === maintenant) { idx = i; break; } }
    if (idx < 0) idx = Math.min(24, p.length - 1);
    ecrire('[data-mc-tendance-passee]', tendance(p[idx] - p[idx - 24], 'depuis hier à la même heure'));
    ecrire('[data-mc-tendance-prevue]', tendance(p[idx + 24] - p[idx], "d'ici demain à la même heure (prévision)"));
    courbe(p, idx);
  }
  function tendance(delta, suffixe) {
    if (typeof delta !== 'number' || isNaN(delta)) return 'Tendance : n.c.';
    var v = Math.round(delta);
    if (Math.abs(delta) < 1.5) return 'Stable ' + suffixe + ' (' + (v > 0 ? '+' : v < 0 ? '−' : '±') + nb0.format(Math.abs(v)) + ' hPa)';
    return (delta > 0 ? 'En hausse de ' : 'En baisse de ') + nb0.format(Math.abs(v)) + ' hPa ' + suffixe;
  }
  function courbe(p, idx) {
    var svg = q('[data-mc-courbe]'), ligne = q('[data-mc-courbe-ligne]'), repere = q('[data-mc-courbe-maintenant]');
    var v = p.filter(function (x) { return typeof x === 'number'; });
    if (!svg || !ligne || v.length < 2) { if (svg) svg.setAttribute('hidden', ''); return; }
    var min = Math.min.apply(null, v), max = Math.max.apply(null, v), amp = Math.max(max - min, 4),
      bas = (min + max) / 2 - amp / 2, W = 300, H = 64, pas = W / (p.length - 1), pts = [];
    p.forEach(function (x, i) { if (typeof x === 'number') pts.push((i * pas).toFixed(1) + ',' + (H - 4 - ((x - bas) / amp) * (H - 8)).toFixed(1)); });
    ligne.setAttribute('points', pts.join(' '));
    if (repere) { repere.setAttribute('x1', (idx * pas).toFixed(1)); repere.setAttribute('x2', (idx * pas).toFixed(1)); }
    svg.removeAttribute('hidden');
    svg.setAttribute('aria-label', 'Pression sur 48 heures, d’hier à demain : de ' + nb0.format(Math.round(min)) + ' à ' + nb0.format(Math.round(max)) + ' hPa.');
    ecrire('[data-mc-courbe-min]', nb0.format(Math.round(min)) + ' hPa');
    ecrire('[data-mc-courbe-max]', nb0.format(Math.round(max)) + ' hPa');
  }

  /* ---------- Branchements ---------- */
  afficherLune();
  majMemoire();
  var bPos = q('[data-mc-position]');
  if (bPos) bPos.addEventListener('click', utiliserPosition);
  var form = q('[data-mc-recherche]');
  if (form) form.addEventListener('submit', function (e) {
    e.preventDefault();
    var champ = form.querySelector('input[type="search"]');
    chercherVille(champ ? champ.value : '');
  });
  var bOubli = q('[data-mc-oublier]');
  if (bOubli) bOubli.addEventListener('click', function () {
    try { localStorage.removeItem(CLE_LIEU); } catch (e) { /* rien */ }
    majMemoire();
    annoncer('Lieu oublié sur cet appareil.');
  });
  var memo = lireLieu();
  if (memo) {
    var coche = q('[data-mc-memoriser]');
    if (coche) coche.checked = true;
    choisirLieu(memo);
  }
})();
